import styles from './style.postcss';

import React, { PureComponent } from 'react';
import { Button } from 'omni-common-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class CardActionButtons extends PureComponent {
  _renderButtons() {
    return [
      <Button type={Button.Type.primary}
          key="save"
          onClick={() => this.props.onPrimaryClick && this.props.onPrimaryClick()}
          disabled={this.props.isPrimaryDisabled}>
        save
      </Button>,
      <Button type={Button.Type.default}
          key="discard"
          onClick={() => this.props.onSecondaryClick && this.props.onSecondaryClick()}
          disabled={this.props.isSecondaryDisabled}>
        discard
      </Button>,
    ];
  }

  render() {
    return <Button.Container className={classnames(styles.BottomButtons, this.props.className)}
        align="right">
      {this._renderButtons()}
    </Button.Container>;
  }
}

CardActionButtons.propTypes = {
  buttons: PropTypes.array,
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func,
  isPrimaryDisabled: PropTypes.bool,
  isSecondaryDisabled: PropTypes.bool,
  className: PropTypes.string,
};

export default CardActionButtons;



// WEBPACK FOOTER //
// ./components/CardActionButtons/index.jsx